export const CLASSIC_SITE_URL = 'https://classic.s-shot.ru';
